import type { ReactElement } from 'react';
import { Navigate, NavLink, Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { CHeader, CHeaderNav, CNavItem, CNavLink, CContainer } from '@coreui/react';
import { getConfig, isConfigured } from '@/services/config.js';
import { PositionsView } from '@/views/PositionsView.js';
import { SettingsView } from '@/views/SettingsView.js';

const Layout = (): ReactElement => (
    <>
        <CHeader className="app-header">
            <CContainer fluid>
                <CHeaderNav>
                    <CNavItem>
                        <CNavLink as={NavLink} to="/" end>
                            Positions
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink as={NavLink} to="/settings">
                            Settings
                        </CNavLink>
                    </CNavItem>
                </CHeaderNav>
            </CContainer>
        </CHeader>
        <CContainer fluid className="py-3">
            <Outlet />
        </CContainer>
    </>
);

const RequireConfig = ({ children }: { children: ReactElement }): ReactElement => {
    if (!isConfigured(getConfig())) {
        return <Navigate to="/settings" replace />;
    }
    return children;
};

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                index: true,
                element: (
                    <RequireConfig>
                        <PositionsView />
                    </RequireConfig>
                ),
            },
            { path: 'settings', element: <SettingsView /> },
        ],
    },
]);

export const App = (): ReactElement => <RouterProvider router={router} />;
